import ActivityConfig from "./ActivityConfig";
import ItemPlayer from "../item/ItemPlayer";
import ItemConfig from "../item/ItemConfig";
import BaseContent from "../utils/BaseContent";
import { Subject, Observable } from "rxjs";

interface ISequenceProps {
  type: string;
  itemList: any[];
  algoConfig: any;
}

export default abstract class BaseActivity extends BaseContent {
  protected itemPlayer: ItemPlayer;
  private itemLoadOverride = false;
  protected activityEventSubject: Subject<any> = new Subject<any>();

  constructor(public config: ActivityConfig) {
    super();
  }
  public overrideLoadResourcesForItem(loadOverride: boolean): void {
    this.itemLoadOverride = loadOverride;
  }
  public get observable(): Observable<any> {
    return this.activityEventSubject.asObservable();
  }

  public async loadItemPlayer(itemConfig: ItemConfig): Promise<void> {
    if (this.config.appConfig) {
      itemConfig.set({ appConfig: this.config.appConfig });
    }
    this.itemPlayer = new ItemPlayer(itemConfig);
    this.itemPlayer.overrideLoad = this.itemLoadOverride;
    await this.itemPlayer.loadLibWithResources();
  }
}
